export default {
    locale_code: 'nb_NO',
    publication_viewer_shopping_list_label: 'Handleliste',
    publication_viewer_shopping_list_clear_button: 'Klar liste',
    publication_viewer_delete_crossed_out_button:
        'Slett overstrekede elementer',
    publication_viewer_print_button: 'Skrive ut',
    publication_viewer_download_button: 'nedlasting',
    publication_viewer_until_label: 'Igjennom',
    publication_viewer_offer_date_range: '{{{from}}} - {{{till}}}',
    publication_viewer_menu_date_range: '{{{from}}} - {{{till}}}',
    publication_viewer_expires_in_days_label: '(Utløper in {{days}} dager)',
    publication_viewer_valid_in_days_label: '(Gyldig om {{days}} dager)',
    publication_viewer_expired_label: '(Utløpt)',
    publication_viewer_pages_button: 'Sider',
    publication_viewer_offers_button: 'Tilbud',
    publication_viewer_search_text: 'Søk',
    publication_viewer_currency: 'NOK',
    publication_viewer_hotspot_picker_header: 'Hvilket tilbud mente du?',
    publication_viewer_overview_button: 'oversikt',
    publication_viewer_close_label: 'Tilbake',
    publication_viewer_add_to_shopping_list: 'Legg til handleliste',
    publication_viewer_visit_webshop_link: 'Besøk nettbutikklink',
    publication_viewer_upcoming: 'Påkommende',
    publication_viewer_offer_price_from: 'Fra',
    publication_viewer_offer_price_for: 'for',
    publication_viewer_offer_valid_from: 'Gjelder kun fra ',
    publication_viewer_no_product_message: 'Ingen produktdetalje',
    publication_viewer_offer_increase_quantity: 'Øk antall',
    publication_viewer_offer_decrease_quantity: 'Minsk antall'
};
